import React, { forwardRef, useEffect } from "react";
import { Button, Modal } from "react-materialize";
import { useCard } from "context/CardContext"; // ✅ Use CardContext

const BirthdayCardModal = forwardRef(() => {
  const { modalState, closeModal } = useCard(); // ✅ Use modalState from context
  const { isOpen, modalKey, modalType, modalHeader, modalText } = modalState; // ✅ Destructure modal state

  useEffect(() => {
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const modalCSS = {
    width: "450px",
    maxHeight: "250px",
    height: "80%",
    margin: "auto",
    top: "50%",
    transform: "translateY(-50%)",
  };

  const renderModalContent = (type, text) => {
    switch (type) {
      case "success":
        return (
          <>
            <button
              className="btn-floating waves-effect waves-light green"
              style={{
                width: "55px",
                height: "55px",
                lineHeight: "85px",
                display: "block",
                margin: "0 auto",
                marginBottom: "25px",
                marginTop: "10px",
              }}
            >
              <i className="material-icons" style={{ fontSize: "2.6rem" }}>
                check
              </i>
            </button>
            <h3 style={{ textAlign: "center" }}>{text}</h3>
          </>
        );
      case "warning":
        return (
          <>
            <button
              className="btn-floating waves-effect waves-light orange"
              style={{
                width: "55px",
                height: "55px",
                lineHeight: "85px",
                display: "block",
                margin: "0 auto",
                marginBottom: "25px",
                marginTop: "10px",
              }}
            >
              <i className="material-icons" style={{ fontSize: "2.6rem" }}>
                warning
              </i>
            </button>
            <h3 style={{ textAlign: "center" }}>{text}</h3>
          </>
        );
      case "error": // ✅ Added "error" type
        return (
          <>
            <button
              className="btn-floating waves-effect waves-light red darken-4"
              style={{
                width: "55px",
                height: "55px",
                lineHeight: "85px",
                display: "block",
                margin: "0 auto",
                marginBottom: "25px",
                marginTop: "10px",
              }}
            >
              <i className="material-icons" style={{ fontSize: "2.6rem" }}>
                close
              </i>
            </button>
            <h3 style={{ textAlign: "center", color: "red" }}>{text}</h3>
          </>
        );
      default:
        return <h3 style={{ textAlign: "center" }}>Unknown Modal Type</h3>;
    }
  };

  return (
    <Modal
      key={`modal-${modalKey}`}
      actions={[
        <div className="header">{modalHeader}</div>,
        <Button
          flat
          modal="close"
          node="button"
          waves="red"
          className="modal-close"
          onClick={closeModal}
        >
          <i className="material-icons">close</i>
        </Button>,
      ]}
      bottomSheet={false}
      fixedFooter={false}
      className="modal-user"
      open={isOpen}
      options={{
        dismissible: true,
        inDuration: 250,
        outDuration: 250,
        preventScrolling: true,
        onCloseEnd: () => {
          console.log("Modal closed");
          closeModal();
        },
        opacity: 0.5,
      }}
      style={modalCSS}
    >
      {renderModalContent(modalType, modalText)}{" "}
      {/* ✅ Use modalType and modalText */}
    </Modal>
  );
});

export default BirthdayCardModal;
